/* Rosabella smooth accordion: <rh-accordion> wrapping <details> items whose panel has [data-rh-panel]. */
(function () {
  if (customElements.get('rh-accordion')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  class RhAccordion extends HTMLElement {
    connectedCallback() {
      var self = this; this.ac = new AbortController(); var sig = { signal: this.ac.signal };
      this.addEventListener('click', function (e) {
        var sum = e.target.closest('summary');
        if (!sum || !self.contains(sum)) return;
        var item = sum.parentElement;
        if (!item || item.tagName !== 'DETAILS') return;
        e.preventDefault();
        self.toggle(item, !item.open || item.classList.contains('is-closing'));
      }, sig);
      document.addEventListener('shopify:block:select', function (e) {
        if (!e.detail || e.detail.sectionId !== self.dataset.sectionId) return;
        var d = self.querySelector('details[data-block-id="' + e.detail.blockId + '"]'); if (d) self.toggle(d, true, true);
      }, sig);
    }
    disconnectedCallback() { if (this.ac) this.ac.abort(); }
    toggle(item, open, instant) {
      var panel = item.querySelector('[data-rh-panel]');
      if (!panel) { item.open = open; return; }
      if (item._rhAnim) { item._rhAnim.cancel(); item._rhAnim = null; }
      var duration = instant || reduce.matches ? 0 : 400;
      if (open) {
        item.classList.remove('is-closing');
        var from = item.open ? panel.getBoundingClientRect().height : 0;
        item.open = true;
        var to = panel.scrollHeight;
        if (!duration || !panel.animate) return;
        item._rhAnim = panel.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: duration, easing: 'ease' });
        item._rhAnim.onfinish = function () { item._rhAnim = null; };
      } else {
        if (!duration || !panel.animate) { item.open = false; return; }
        var h = panel.getBoundingClientRect().height;
        item.classList.add('is-closing');
        item._rhAnim = panel.animate([{ height: h + 'px' }, { height: '0px' }], { duration: duration, easing: 'ease' });
        item._rhAnim.onfinish = function () { item._rhAnim = null; item.open = false; item.classList.remove('is-closing'); };
        item._rhAnim.oncancel = function () { item.classList.remove('is-closing'); };
      }
    }
  }
  customElements.define('rh-accordion', RhAccordion);
})();
